// .post-body内の最初のdetails要素をデフォルトで開く
document.addEventListener('DOMContentLoaded', function() {
  const postBody = document.querySelector('.post-body');
  if (postBody) {
    const firstDetails = postBody.querySelector('details');
    if (firstDetails) {
      firstDetails.open = true;
    }
  }
});

